import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AddLocation, AddLocationError, AddLocationSuccess, DeleteLocation, DeleteLocationError, DeleteLocationSuccess, LocationsError, LocationsLoaded, LocationsRequested, UpdateLocation, UpdateLocationError, UpdateLocationSuccess } from './locations.actions';
import { ClientService } from '../../@core/data/clients/client.service';
import { co } from '@fullcalendar/core/internal-common';
import { ToastrConfigs } from '../../@core/data/toastr-config';
import { NbToastrService } from '@nebular/theme';
import { LocationService } from '../../@core/data/location/location.service';


@Injectable()
export class LocationsEffects {
  constructor(
    private actions$: Actions,
    private locationService: LocationService,
    private toastrService: NbToastrService
  ) {}

  requestLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationsRequested),
      mergeMap(() =>
        this.locationService.getLocations().pipe(
          map((res: any) => { 
            return LocationsLoaded({ locations: res?.data })}),
          catchError((error: any) => of(LocationsError()))
        ) 
      )
    )
  );

  addLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddLocation),
      mergeMap((action) =>
        this.locationService.saveLocation(action.location).pipe(
          map((response: any) => {
            const locationWithId = { ...response.data };
            this.toastrService.success('Locație articol salvată cu succes', 'Success', { ...ToastrConfigs.success });
            return AddLocationSuccess({ location: locationWithId });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare salvare locație articol', 'Error', { ...ToastrConfigs.danger });
            return of(AddLocationError());
          })
        )
      )
    )
  );
  updateLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateLocation),
      mergeMap((action) =>
        this.locationService.updateLocation(action.location).pipe(
          map((response: any) => {
            const updatedLocation = { ...response.data };
            if (!action.skipToast) {
              this.toastrService.success('Locație articol actualizată cu succes', 'Success', { ...ToastrConfigs.success });
            }
            return UpdateLocationSuccess({ location: updatedLocation  });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare actualizare locație articol', 'Error', { ...ToastrConfigs.danger });
            return of(UpdateLocationError());
          })
        )
      )
    )
  );

  deleteLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteLocation),
      mergeMap(action =>
        this.locationService.deleteLocation(action.id).pipe(
          map(() => {
            this.toastrService.success('Locație articol ștearsă cu succes', 'Success', { ...ToastrConfigs.success });
            return DeleteLocationSuccess({ id: action.id });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare ștergere locație articol', 'Error', { ...ToastrConfigs.danger });
            return of(DeleteLocationError());
          })
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LocationsError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
